export const DEFAULT_STYLE = {
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none'
  },
  iconCenter: {
    animation: 'ftv-magneto-feedback-animation .64s'
  },
  iconRight: {
    animation: 'ftv-magneto-feedback-animation .64s',
    marginLeft: '50%'
  },
  iconLeft: {
    animation: 'ftv-magneto-feedback-animation .64s',
    marginRight: '50%'
  }
};

export const DEFAULT_ICON = {
  width: 120,
  height: 120
};
